import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import history from 'pages/router/history';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import qs from 'qs';
import get from 'lodash/get';

import { Alert } from '@lightspeed/flame/Alert';
import { Button } from '@lightspeed/flame/Button';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import { Divider } from '@lightspeed/flame/Divider';
import { IconExport } from '@lightspeed/flame/Icon/Export';

import Pager from 'pages/containers/Pager';
import SearchBar from 'pages/containers/SearchBar';

import { getProcessing, getValues, getMeta, getErrors } from 'pages/store/selectors';
import { endpoints, entities } from 'pages/store/schema';
import { actionTypes } from 'pages/store/actions/defaults';
import { clearData, getData, putData, deleteData } from 'pages/store/actions/data';
import TableBulkAction from 'pages/containers/TableBulkAction';

import { Box } from '@lightspeed/flame/Core';
import VendorReturnItemListingForm from './VendorReturnItemListingForm';
import {
  ItemsHeader,
  ListingActions,
  ListingActionsBottom,
  ItemsHeaderTitle,
} from './VendorReturnItemListing.style';

class VendorReturnItemListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInit: false,
    };

    this.historyDetach = null;
    this.alertRef = React.createRef();
    this.updateVendorReturnItem = this.updateVendorReturnItem.bind(this);
    this.updateVendorReturnItemTax = this.updateVendorReturnItemTax.bind(this);
    this.resetVendorReturnItemTax = this.resetVendorReturnItemTax.bind(this);
    this.updateVendorNumber = this.updateVendorNumber.bind(this);
    this.getVendorReturnItemsData = this.getVendorReturnItemsData.bind(this);
  }

  componentDidMount() {
    const { location: { search } = {}, getItemReasonData } = this.props;
    getItemReasonData();
    if (search) {
      this.getVendorReturnItemsData();
    } else {
      history.replace({
        pathname: location.pathname,
        search: qs.stringify({ sort: 'addOrder' }),
      });
    }
    this.historyDetach = history.listen(() => {
      this.getVendorReturnItemsData();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { location = {}, isLoading, loadingOrSavingErrors } = this.props;
    if (!prevState.dataInit && prevProps.isLoading && !isLoading) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(() => ({
        dataInit: true,
      }));
    }

    if (location.search !== prevProps.location.search) {
      this.getVendorReturnItemsData();
    }

    if (!prevProps.loadingOrSavingErrors && loadingOrSavingErrors) {
      window.scroll({
        top: this.alertRef.current.offsetTop,
      });
    }
  }

  componentWillUnmount() {
    this.historyDetach?.(); // eslint-disable-line
    this.props.clearData();
  }

  getVendorReturnItemsData() {
    const { location = {}, vendorReturnID, getListingData } = this.props;
    const search = qs.parse(location.search, { ignoreQueryPrefix: true });

    getListingData({ vendorReturnID, ...search });
  }

  updateVendorReturnItemTax({
    itemID,
    vendorReturnItemTaxID,
    newTaxRate,
    onSuccess = () => {},
    shouldUpdateVendorReturn = false,
  }) {
    const {
      vendorReturnID,
      putDataVendorReturnItemTax,
      getListingData,
      getVendorReturnData,
    } = this.props;
    putDataVendorReturnItemTax({
      vendorReturnID,
      itemID,
      vendorReturnItemTaxID,
      payload: { vendorReturnItemTax: { taxRate: newTaxRate } },
      onSuccess: () => {
        onSuccess();
        if (shouldUpdateVendorReturn) {
          getVendorReturnData(vendorReturnID);
          getListingData({ vendorReturnID });
        }
      },
    });
  }

  resetVendorReturnItemTax({ itemID, payload, onSuccess = () => {} }) {
    const {
      vendorReturnID,
      resetVendorReturnItemTax,
      getVendorReturnData,
      getListingData,
    } = this.props;

    resetVendorReturnItemTax({
      vendorReturnID,
      itemID,
      payload,
      onSuccess: () => {
        onSuccess();
        getVendorReturnData(vendorReturnID);
        getListingData({ vendorReturnID });
      },
    });
  }

  updateVendorReturnItem({
    itemID,
    payload,
    onSuccess = () => {},
    shouldUpdateVendorReturn = false,
  }) {
    const { vendorReturnID, putDataVendorReturns, getVendorReturnData } = this.props;

    putDataVendorReturns({
      vendorReturnID,
      itemID,
      payload,
      onSuccess: () => {
        onSuccess();
        if (shouldUpdateVendorReturn) {
          getVendorReturnData(vendorReturnID);
        }
      },
    });
  }

  updateVendorNumber({ itemID, payload, onSuccess = () => {} }) {
    const { vendorID, putVendorNumber } = this.props;

    putVendorNumber({
      vendorID,
      itemID,
      payload,
      onSuccess: () => {
        onSuccess();
      },
    });
  }

  render() {
    const {
      vendorReturnID,
      meta: { pagination = {} } = {},
      isLoading,
      isDeleting,
      isArchived,
      vendorID,
      items,
      itemsExist,
      loadingOrSavingErrors,
      reasons,
      updateItem,
      deleteVendorReturnItems,
      getVendorReturnData,
    } = this.props;
    const { dataInit } = this.state;

    return (
      <Fragment>
        <div ref={this.alertRef}>
          {loadingOrSavingErrors ? (
            <Alert title="Items error" type="danger" className="cr-width-full cr-mb-4">
              {get(
                loadingOrSavingErrors,
                'response.data.errors[0].detail',
                'An error has occurred. Please reload the page and try again'
              )}
            </Alert>
          ) : null}
        </div>
        <ItemsHeader>
          <ItemsHeaderTitle heading3>Items</ItemsHeaderTitle>
          {!window.isGriffin() && itemsExist && (
            <Button
              className="cr-button-link"
              href={`/admin/vendor-returns/${vendorReturnID}/items/export`}
              data-test="vendor-return-items-export-button"
            >
              <IconExport /> Export
            </Button>
          )}
        </ItemsHeader>
        <Card>
          <CardSection noSpacing>
            <ListingActions>
              <SearchBar />
              <Pager pagination={pagination} />
            </ListingActions>
            <Divider />
          </CardSection>
          <CardSection noSpacing>
            {/* This table can get pretty large so we use `overflowX: auto` to keep in contained */}
            <Box style={{ overflowX: 'auto' }}>
              <TableBulkAction
                data={items}
                actionType="delete"
                dataType="item"
                dataIdPath="Item.data.itemID"
                dataDescriptionPath="Item.data.description"
                confirmRest={{ danger: true }}
                action={itemIds =>
                  deleteVendorReturnItems({
                    vendorReturnID,
                    payload: { items: itemIds },
                    onSuccess: () => {
                      const search = qs.parse(window.location.search, { ignoreQueryPrefix: true });
                      window.flashNotifier(
                        'success',
                        `<var>${itemIds.length}</var> item${
                          itemIds.length > 1 ? 's' : ''
                        } deleted.`,
                        5
                      );
                      history.replace({
                        pathname: location.pathname,
                        search: qs.stringify({
                          ...search,
                          page: { number: 1 },
                        }),
                      });
                      getVendorReturnData(vendorReturnID);
                    },
                  })
                }
                actionCallback={this.getVendorReturnItemsData}
              >
                <VendorReturnItemListingForm
                  vendorID={vendorID}
                  vendorReturnID={vendorReturnID}
                  items={items}
                  itemsExist={itemsExist}
                  reasons={reasons}
                  isLoading={isLoading}
                  isDeleting={isDeleting}
                  isArchived={isArchived}
                  dataInit={dataInit}
                  updateVendorReturnItem={this.updateVendorReturnItem}
                  updateVendorReturnItemTax={this.updateVendorReturnItemTax}
                  resetVendorReturnItemTax={this.resetVendorReturnItemTax}
                  updateVendorNumber={this.updateVendorNumber}
                  updateItem={updateItem}
                />
              </TableBulkAction>
              <Divider />
            </Box>
          </CardSection>
          <CardSection noSpacing>
            <ListingActionsBottom>
              <Pager pagination={pagination} />
            </ListingActionsBottom>
          </CardSection>
        </Card>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  items: getValues(entities.vendorReturnItem)(state),
  reasons: getValues(entities.vendorReturnItemReason)(state),
  meta: getMeta({ entity: entities.vendorReturnItem, list: true })(state),
  isLoading:
    getProcessing({
      entity: entities.vendorReturnItem,
      list: true,
      actionType: actionTypes.LOADING,
    })(state) ||
    getProcessing({
      entity: entities.vendorReturnItem,
      list: false,
      actionType: actionTypes.SAVING,
    })(state) ||
    getProcessing({
      entity: entities.vendorReturnItemReason,
      list: false,
      actionType: actionTypes.LOADING,
    })(state),
  isDeleting: getProcessing({
    entity: entities.vendorReturnItem,
    list: false,
    actionType: actionTypes.DELETING,
  })(state),
  loadingOrSavingErrors:
    getErrors({ entity: entities.vendorReturnItem, list: true, actionType: actionTypes.LOADING })(
      state
    ) ||
    getErrors({ entity: entities.vendorReturnItem, list: false, actionType: actionTypes.SAVING })(
      state
    ) ||
    getErrors({ entity: entities.vendorReturnItem, list: false, actionType: actionTypes.DELETING })(
      state
    ),
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  getVendorReturnData: id => dispatch(getData(endpoints.vendorReturns.view({ id }))),
  getListingData: ({ vendorReturnID, page, sort, filter }) =>
    dispatch(getData(endpoints.vendorReturnItem.list({ vendorReturnID, page, sort, filter }))),
  getItemReasonData: () => dispatch(getData(endpoints.vendorReturnItemReason.listAll())),
  putDataVendorReturnItemTax: ({
    vendorReturnID,
    itemID,
    vendorReturnItemTaxID,
    payload,
    onSuccess,
  }) =>
    dispatch(
      putData(
        endpoints.vendorReturnItemTax.edit({
          vendorReturnID,
          itemID,
          vendorReturnItemTaxID,
          payload,
          onSuccess,
        })
      )
    ),
  putDataVendorReturns: ({ vendorReturnID, itemID, payload, onSuccess }) =>
    dispatch(
      putData(endpoints.vendorReturnItem.edit({ vendorReturnID, itemID, payload, onSuccess }))
    ),
  resetVendorReturnItemTax: ({ vendorReturnID, itemID, payload, onSuccess }) => {
    dispatch(
      putData(
        endpoints.vendorReturnResetItemTax.reset({ vendorReturnID, itemID, payload, onSuccess })
      )
    );
  },
  putVendorNumber: ({ vendorID, itemID, payload, onSuccess }) =>
    dispatch(putData(endpoints.vendorNumber.edit({ vendorID, itemID, payload, onSuccess }))),
  deleteVendorReturnItems: ({ vendorReturnID, payload, onSuccess }) =>
    dispatch(deleteData(endpoints.vendorReturnItem.delete({ vendorReturnID, payload, onSuccess }))),
  clearData: () =>
    dispatch(clearData([entities.vendorReturnItem, entities.vendorReturnItemReason])),
});

const ConnectedVendorReturnItemListing = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(VendorReturnItemListing));

ConnectedVendorReturnItemListing.propTypes = {
  vendorReturnID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  vendorID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  updateItem: PropTypes.bool,
};

export default ConnectedVendorReturnItemListing;
